import { Dialog } from "@angular/cdk/dialog";
import {
    createNgModule,
    inject,
    Injectable,
    Injector,
    NgModuleRef,
    OnDestroy,
} from "@angular/core";

import { Subscription } from "rxjs";

import type { ShadeFinderModalModule } from "@hermes/fragments/shade-finder-modal";
import { ShadeFinderFacade } from "@hermes/states/shade-finder";

@Injectable()
export class ShadeFinderModalService implements OnDestroy {
    private static moduleRef: NgModuleRef<ShadeFinderModalModule>;

    public facade!: ShadeFinderFacade;

    private subscription = new Subscription();

    constructor(private injector: Injector, public dialog: Dialog) {
        this.facade = inject(ShadeFinderFacade);
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    public async openShadeFinderModal(): Promise<void> {
        this.facade.openModal();
        const configDialog = {
            panelClass: ["modal-service"],
            disableClose: true,
            ariaLabel: "label to be defined",
        };
        this.dialog.open(
            await this.getShadeFinderModalComponent(),
            configDialog,
        );
    }

    public async getShadeFinderModalComponent() {
        if (!ShadeFinderModalService.moduleRef) {
            const shadeFinderModalModule = await import(
                "@hermes/fragments/shade-finder-modal"
            );
            ShadeFinderModalService.moduleRef = createNgModule(
                shadeFinderModalModule.ShadeFinderModalModule,
                this.injector,
            );
        }
        return (
            ShadeFinderModalService.moduleRef.instance as ShadeFinderModalModule
        ).resolveComponent();
    }
}
